import React, { type FC, type ImgHTMLAttributes, type PropsWithChildren } from 'react';

import type { ComponentImage } from '../../types/generics';
import Image from '../image/image';

export interface AvatarProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'alt' | 'src'>, ComponentImage {
  size?: 'medium' | 'large';
}

const Avatar: FC<PropsWithChildren<AvatarProps>> = ({ className, imageAlt, imageSrc, size = 'medium', ...rest }) => (
  <Image
    {...rest}
    css={[
      {
        label: 'avatar',
        borderRadius: '50%',
        height: '110px',
        width: '110px',
      },
      size === 'medium' && {
        height: '60px',
        width: '60px',
      },
    ]}
    // eslint-disable-next-line @stylistic/jsx-sort-props
    className={className}
    imageAlt={imageAlt || ''}
    imageSrc={imageSrc}
  />
);

export { Avatar };
export default Avatar;
